export const countriesStub = `[
    {
      "Aliases": [
        "Beijing",
        "shanghai"
      ],
      "CountryId": 46,
      "Country": "China",
      "CountryLocal": "סין",
      "CountryPhoneCode": "86",
      "PopularityOrder": 7,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
    },
    {
      "Aliases": [
        ""
      ],
      "CountryId": 67,
      "Country": "Fiji",
      "CountryLocal": "פיג'י",
      "CountryPhoneCode": "679",
      "PopularityOrder": 5,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
    },
    {
      "Aliases": [
        "Delhi",
        "Mumbai"
      ],
      "CountryId": 99,
      "Country": "India",
      "CountryLocal": "הודו",
      "CountryPhoneCode": "91",
      "PopularityOrder": 6,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
    },
    {
      "Aliases": [
        "Bali"
      ],
      "CountryId": 96,
      "Country": "Indonesia",
      "CountryLocal": "אינדונזיה",
      "CountryPhoneCode": "62",
      "PopularityOrder": 2,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
    },
    {
      "Aliases": [
        "Rome",
        "Venice",
        "Florence"
      ],
      "CountryId": 104,
      "Country": "Italy",
      "CountryLocal": "איטליה",
      "CountryPhoneCode": "39",
      "PopularityOrder": 9,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
    },
    {
      "Aliases": [
        "Tokyo"
      ],
      "CountryId": 108,
      "Country": "Japan",
      "CountryLocal": "יפן",
      "CountryPhoneCode": "81",
      "PopularityOrder": 10,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
    },
    {
      "Aliases": [
        "Bangkok",
        "phuket"
      ],
      "CountryId": 206,
      "Country": "Thailand",
      "CountryLocal": "תאילנד",
      "CountryPhoneCode": "66",
      "PopularityOrder": 8,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
    },
    {
      "Aliases": [
        ""
      ],
      "CountryId": 32,
      "Country": "Bhutan",
      "CountryLocal": "בהוטן",
      "CountryPhoneCode": "975",
      "PopularityOrder": 0,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
    },
    {
      "Aliases": [
        ""
      ],
      "CountryId": 29,
      "Country": "Bolivia",
      "CountryLocal": "בוליביה",
      "CountryPhoneCode": "591",
      "PopularityOrder": 0,
      "IsCovered": false,
      "AreaId": 0,
      "Phone": ""
  }]`;
